import React from 'react';
import { Helmet } from 'react-helmet';

export default function About({ t }) {
    return (
        <div className="animate-fadeIn pb-20">
            <Helmet>
                <title>About Us — Alum Nawatha LTD | 40+ Years of Aluminum Excellence</title>
                <meta name="description" content="Founded in 1986, Alum Nawatha LTD is Northern Israel's leading aluminum manufacturer with 40+ years of experience in precision windows, doors, and facades." />
            </Helmet>
            {/* Header Section */}
            <div className="bg-slate-900 text-white py-24 text-center">
                <h1 className="text-5xl font-black uppercase mb-4">{t.aboutTitle}</h1>
                <div className="w-20 h-1 bg-blue-600 mx-auto"></div>
            </div>

            <div className="container mx-auto px-6 -mt-10">
                <div className="bg-white shadow-2xl rounded-[3rem] p-10 md:p-20 flex flex-col items-center">

                    {/* LOGO SEAL */}
                    <img
                        src="/assets/logo-circle.png"
                        loading="lazy"
                        decoding="async"
                        width="128"
                        height="128"
                        className="w-32 h-32 mb-12 animate-pulse transition-all hover:scale-110"
                        alt="Quality Seal"
                    />

                    <div className="max-w-3xl text-center">
                        <p className="text-xl text-slate-600 leading-relaxed mb-10">
                            {t.aboutText}
                        </p>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pt-10 border-t border-slate-100">
                            <div>
                                <h4 className="text-4xl font-black text-blue-700">40+</h4>
                                <p className="text-slate-400 uppercase text-xs font-bold tracking-widest mt-2">{t.experience}</p>
                            </div>
                            <div>
                                <h4 className="text-4xl font-black text-blue-700">1986</h4>
                                <p className="text-slate-400 uppercase text-xs font-bold tracking-widest mt-2">{t.foundedLabel}</p>
                            </div>
                            <div>
                                <h4 className="text-4xl font-black text-blue-700">100%</h4>
                                <p className="text-slate-400 uppercase text-xs font-bold tracking-widest mt-2">{t.precisionLabel}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}